
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  description: "Learn how Link proactively notifies users if an institution's connection is responsible for an error.",
  preloadImages: [{
    src: '/assets/img/docs/institution-status-in-link.png',
    type: 'image/webp'
  }]
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const Image = makeShortcode("Image");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Institution status in Link' subtitle='Details of institution health status accessible in Link' mdxType="Header" />
    <h4 {...{
      "id": "institution-status-in-link"
    }}>{`Institution status in Link`}</h4>
    <p>{`Link proactively lets users know if an institution's connection isn't performing well.
Below are the three views a user will see depending on the status of the institution they select.`}</p>
    <p>{`When the status of `}<inlineCode parentName="p">{`item_logins`}</inlineCode>{` of an institution is `}<inlineCode parentName="p">{`DEGRADED`}</inlineCode>{`, Link will warn
users that they may experience issues and allow them to continue. Once the
status of `}<inlineCode parentName="p">{`item_logins`}</inlineCode>{` becomes `}<inlineCode parentName="p">{`DOWN`}</inlineCode>{`, Link will block users from attempting to
log in and suggest they find another bank.`}</p>
    <Image src='/assets/img/docs/institution-status-in-link.png' alt="Plaid Link institution status panels: Healthy allows credential input; Degraded shows connectivity issue; Down indicates connection failure." width='624' expandable={true} mdxType="Image" />
    <p>{`Institution Health warnings can be tested in the Sandbox environment by using one of the dedicated `}<a parentName="p" {...{
        "href": "/docs/sandbox/institutions/#institution-details"
      }}>{`"Unhealthy" Platypus Bank test institutions`}</a>{`.`}</p>
    <p>{`For a more detailed view of institution health, see the `}<a parentName="p" {...{
        "href": "https://dashboard.plaid.com/activity/status"
      }}>{`Institutions page`}</a>{`, which provides a browsable view of institutions, supported products, and institution health.`}</p>
    <h4 {...{
      "id": "connectivity-not-supported"
    }}>{`Connectivity not supported`}</h4>
    <Image src='/assets/img/docs/link-connectivity-not-supported.png' alt="Plaid Link message: 'Connectivity not supported' for simple institution. Advises trying another institution." width='250' expandable={true} mdxType="Image" />
    <p>{`If an institution is supported by Plaid, but is not supported by the product set or country codes Link was initialized with, a "Connectivity not supported" error message will appear. This message does not reflect the health of the institution. This message can be resolved by calling `}<inlineCode parentName="p">{`/link/token/create`}</inlineCode>{` with a more minimal product set, or by making sure you are Production-enabled for the country you are initializing Link for. For more details, see `}<a parentName="p" {...{
        "href": "/docs/link/troubleshooting/#missing-institutions-or-connectivity-not-supported-error"
      }}>{`Link troubleshooting`}</a>{`.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "institution-status-in-link",
        level: 4,
        title: "Institution status in Link",
      },
{
        id: "connectivity-not-supported",
        level: 4,
        title: "Connectivity not supported",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
